import { styled } from 'goober';

import { colors } from '@/theme/colors';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { Logo } from '@/ui/logo/logo';

export const NotificationCardContainer = styled(Flexbox)<{
  isRead: boolean;
  clickable?: boolean;
}>`
  border-radius: 10px;
  border: 1px ${colors.gray.c3} solid;
  padding: 16px;
  background-color: ${({ isRead }) =>
    isRead ? colors.blue.c9 : colors.basics.white};
  cursor: ${({ clickable = true }) => (clickable ? 'pointer' : 'default')};
`;

export const NotificationIconWrapper = styled(Flexbox)<{
  isRead: boolean;
  unreadColor?: string;
}>`
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background-color: ${({ isRead, unreadColor = colors.blue.primaryA }) =>
    isRead ? colors.system.disable : unreadColor};
`;

export const NotificationAuthorInitials = styled(Logo)`
  font-weight: 600;
`;

export const NotificationHighlight = styled('span')`
  font-weight: 600;
  color: ${colors.basics.black};
`;
